import { useState } from 'react';
import { InstallPrompt } from '../components/InstallPrompt';

const CARDS = [
  {
    icon: '📍',
    title: 'Here is your turf',
    body: 'Your assigned blocks are outlined on the map and listed in walking order. Everything outside your turf is dimmed so you can’t wander off by accident.',
  },
  {
    icon: '🚪',
    title: 'Tap a house to knock',
    body: 'Not home is one tap. A real conversation is two: pick a support level, then Save & next. The closest unvisited door loads automatically.',
  },
  {
    icon: '📶',
    title: 'Your data is always safe',
    body: 'Every door saves on your phone first — even with no signal. The strip at the top always shows how many records are waiting to sync. You will never lose a door.',
  },
];

/** One-time 3-card tutorial. Skippable; never shown again once finished. */
export function FirstRun({ onDone }: { onDone: () => void }) {
  const [i, setI] = useState(0);
  const last = i === CARDS.length - 1;
  const card = CARDS[i]!;

  return (
    <div className="fullcenter">
      <div className="center">
        <div style={{ fontSize: 56 }} aria-hidden>
          {card.icon}
        </div>
        <h2 style={{ marginTop: 8 }}>{card.title}</h2>
        <p className="muted" style={{ fontSize: 'calc(16px * var(--scale))' }}>
          {card.body}
        </p>
      </div>

      {i === 0 && (
        <div className="center">
          <InstallPrompt />
          <p className="muted" style={{ fontSize: 'calc(12px * var(--scale))' }}>
            Add to your home screen so it opens like an app and works offline.
          </p>
        </div>
      )}

      <div className="dots">
        {CARDS.map((_, n) => (
          <i key={n} className={n === i ? 'on' : ''} />
        ))}
      </div>

      <div className="col">
        <button className="btn btn-primary btn-lg" onClick={() => (last ? onDone() : setI(i + 1))}>
          {last ? 'Start canvassing' : 'Next'}
        </button>
        {!last && (
          <button className="btn btn-block" onClick={onDone}>
            Skip
          </button>
        )}
      </div>
    </div>
  );
}
